'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chromeLight = exports.chromeDark = undefined;

var _chromeDark2 = require('./chromeDark');

var _chromeDark3 = _interopRequireDefault(_chromeDark2);

var _chromeLight2 = require('./chromeLight');

var _chromeLight3 = _interopRequireDefault(_chromeLight2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.chromeDark = _chromeDark3.default;
exports.chromeLight = _chromeLight3.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-inspector/lib/styles/themes/index.js
// module id = 210
// module chunks = 0 1